export const Font = {
  'Muli': '"Muli", sans-serif',
  'Georgia': 'Georgia, serif',
  'Palatino Linotype': '"Palatino Linotype", "Book Antiqua", Palatino, serif',
  'Times New Roman': '"Times New Roman", Times, serif',
  'Helvetica': 'Helvetica, sans-serif',
  'Arial': 'Arial, Helvetica, sans-serif',
  'Roboto': 'Roboto',
  'Impact': 'Impact, Charcoal, sans-serif',
  'Comic Sans MS': '"Comic Sans MS", cursive, sans-serif',
  'Lucida': '"Lucida Sans Unicode", "Lucida Grande", sans-serif',
  'Tahoma': 'Tahoma, Geneva, sans-serif',
  'Verdana': 'Verdana, Geneva, sans-serif',
  'Courier New': '"Courier New", Courier, monospace',
  'Lucida Console': '"Lucida Console", Monaco, monospace',
};
